import script from "./KnowlegeCategoryEdit.vue?vue&type=script&lang=ts&setup=true"
export * from "./KnowlegeCategoryEdit.vue?vue&type=script&lang=ts&setup=true"

import "./KnowlegeCategoryEdit.vue?vue&type=style&index=0&id=4ff9f587&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ff9f587"]])

export default __exports__